export default __webpack_public_path__ + "static/media/announcementexample.ee9a0d07.jpg";